import { getAcademySchoolOptions } from "../data/schools.js";
import { schoolDisplayName } from "./schoolDisplay.js";

// Keep region-qualified stored values distinct; strip only a recognized display suffix.
export const studentSchoolName = schoolDisplayName;

export function studentSchoolOptions(academyInfo = {}, schoolLevel = "") {
  return getAcademySchoolOptions(academyInfo, schoolLevel).map((option) => ({
    ...option,
    label: studentSchoolName(option.value, academyInfo),
  }));
}
